import { Box, Button, Typography } from '@mui/material'

import { useRouter } from '@/core'

export type MembershipRecommendBoxProps = {
  artistId: string
  membershipRecommendTitle: string
  membershipRecommendText: string
  recommendButtonText: string
}

export const MembershipRecommendBox = (props: MembershipRecommendBoxProps) => {
  const { routerPages, router, generatePath } = useRouter()
  return (
    <Box
      id="modal-inner"
      sx={{
        width: 280,
        borderRadius: 3,
        px: 5,
        py: 7,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'grey.100',
        outline: 'none',
        textAlign: 'center',
        ...Object.assign({}),
      }}
    >
      <Typography variant="h5" sx={{ pb: 3 }}>
        {props.membershipRecommendTitle}
      </Typography>
      <Typography variant="body2" sx={{ pb: 7 }}>
        <>
          <p>{props.membershipRecommendText}</p>
          <Button
            color="primary"
            size="large"
            fullWidth
            onClick={() => {
              router.push(
                generatePath(routerPages.ArtistMembership, {
                  artistId: props.artistId,
                })
              )
            }}
          >
            {props.recommendButtonText}
          </Button>
        </>
      </Typography>
    </Box>
  )
}
